import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { HashNavigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import PageHeader from '../../components/PageHeader';
import RequestService from '../../services/RequestService';
import TypesService from '../../services/TypesService';
import AddressSlide from './AddressSlide';

import 'swiper/css';
import 'swiper/css/pagination';
import './Address.scss';

const CurrenciesById = TypesService.CurrenciesById;
const BlockchainsById = TypesService.BlockchainsById;

const Address = () => {
	const [loading, setLoading] = useState(true);
	const [addresses, setAddresses] = useState([]);
	// const [currencyId, setCurrencyId] = useState();

	const location = useLocation();
	const [searchParams] = useSearchParams();

	const addressId = Number(location.hash.slice(1));
	const currencyId = Number(searchParams.get('currencyId'));

	const currencyData = CurrenciesById[currencyId];
	const blockchainData = BlockchainsById[currencyData?.BlockchainId];

	useEffect(() => {
		const fetchAddresses = async () => {
			try {
				const res = await RequestService.GetAddressesByCurrency(currencyId);

				setAddresses(res.Addresses);

				setLoading(false);
			} catch (error) {
				console.log(error);
			}
		};

		fetchAddresses();
		// setCurrencyId(currencyId);
	}, []);

	// const getBulletSizes = (activeIndex, bulletCount) => {
	// 	const bulletSizes = Array.from({ length: bulletCount }, () => 0);
	// 	bulletSizes[activeIndex] = 8;
	// 	const slideDirectionToStart =
	// 		activeSlideIndex === null ? activeIndex < bulletCount / 2 : activeIndex <= activeSlideIndex;
	// 	setActiveSlideIndex(activeIndex);
	// 	const defaultRightBulletCount = slideDirectionToStart ? 4 : 3;

	// 	let rightVisibleBulletCount = 0;
	// 	while (
	// 		rightVisibleBulletCount < bulletCount - activeIndex - 1 &&
	// 		rightVisibleBulletCount < 7 - Math.min(activeIndex, 7 - defaultRightBulletCount)
	// 	) {
	// 		bulletSizes[activeIndex + rightVisibleBulletCount + 1] = 8;
	// 		rightVisibleBulletCount++;
	// 	}

	// 	let leftVisibleBulletCount = 0;
	// 	while (leftVisibleBulletCount < activeIndex && leftVisibleBulletCount < 7 - rightVisibleBulletCount) {
	// 		bulletSizes[activeIndex - leftVisibleBulletCount - 1] = 8;
	// 		leftVisibleBulletCount++;
	// 	}

	// 	if (leftVisibleBulletCount > 1) {
	// 		bulletSizes[activeIndex - leftVisibleBulletCount] = 4;
	// 		bulletSizes[activeIndex - leftVisibleBulletCount + 1] = 6;
	// 	} else if (leftVisibleBulletCount > 0) {
	// 		bulletSizes[activeIndex - leftVisibleBulletCount] = 6;
	// 	}

	// 	if (rightVisibleBulletCount > 1) {
	// 		bulletSizes[activeIndex + rightVisibleBulletCount] = 4;
	// 		bulletSizes[activeIndex + rightVisibleBulletCount - 1] = 6;
	// 	} else if (rightVisibleBulletCount > 0) {
	// 		bulletSizes[activeIndex + rightVisibleBulletCount] = 6;
	// 	}

	// 	return bulletSizes;
	// };

	return (
		<div className='Address' style={{ '--currency-color': currencyData?.Color }}>
			<PageHeader
				icon={currencyData?.Name}
				iconLabel={currencyData?.CompanyIcon !== blockchainData?.Icon ? blockchainData?.Icon : null}
				collapsed={true}
				header={<>{currencyData?.Name + ' ' + currencyData?.Standart}</>}
			/>
			<div className='Address__swiper'>
				{/* <div className='Address__swiper-pagination'></div> */}
				{!addresses || addresses?.length === 0 ? (
					<AddressSlide
						address={{ BlockchainId: currencyData?.BlockchainId, CurrencyId: currencyId, AddressId: addressId }}
						loading={loading}
					/>
				) : (
					<Swiper
						hashNavigation={{ watchState: true, replaceState: true }}
						modules={[HashNavigation, Pagination]}
						pagination={{
							dynamicBullets: true,
							dynamicMainBullets: 5,
							// el: '.Address__swiper-pagination',
							// renderBullet: () => '<div class="Address__swiper-pagination-bullet"></div>',
						}}
						// onPaginationRender={(swiper, paginationEl) => {
						// 	if (swiper.destroyed) return;
						// 	const bulletSizes = getBulletSizes(swiper.activeIndex, paginationEl.childElementCount);
						// 	[...paginationEl.childNodes].map((node, index) => {
						// 		node.style.width = bulletSizes[index] + 'px';
						// 		node.style.height = bulletSizes[index] + 'px';
						// 		if (bulletSizes[index] === 0) {
						// 			node.style.display = 'none';
						// 		} else {
						// 			node.style.display = 'block';
						// 		}
						// 		if (index === swiper.activeIndex) {
						// 			node.classList.add('Address__swiper-active-bullet');
						// 		} else {
						// 			node.classList.remove('Address__swiper-active-bullet');
						// 		}
						// 	});
						// 	paginationEl.style.animation = 'none';
						// 	setTimeout(() => (paginationEl.style.animation = null));
						// }}
						touchReleaseOnEdges={true}
					>
						{addresses.map(address => (
							<SwiperSlide data-hash={address.AddressId} key={address.AddressId}>
								<AddressSlide address={address} />
							</SwiperSlide>
						))}
					</Swiper>
				)}
			</div>
		</div>
	);
};

export default Address;
